import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "hy-switches" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "mr-4" }
const _hoisted_4 = { class: "d-inline-block mb-2" }


export default /*@__PURE__*/_defineComponent({
  __name: 'Switches',
  async setup(__props) {

let __temp: any, __restore: any


const { field, control, inputModel, handleUpdate } = inject('input') as InputInjection

const items = (
  ([__temp,__restore] = _withAsyncContext(() => field.value.items())),
  __temp = await __temp,
  __restore(),
  __temp
)


return (_ctx: any,_cache: any) => {
  const _component_hy_inputs_help_marker = _resolveComponent("hy-inputs-help-marker")!
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(control).help)
          ? (_openBlock(), _createBlock(_component_hy_inputs_help_marker, {
              key: 0,
              "help-prompt": _unref(control).help
            }, null, 8, ["help-prompt"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(control).label), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (option) => {
      return (_openBlock(), _createBlock(_component_v_switch, {
        modelValue: _unref(inputModel),
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputModel) ? (inputModel).value = $event : null)),
          _unref(handleUpdate)
        ],
        color: "primary",
        density: "compact",
        key: option,
        label: option,
        value: option
      }, null, 8, ["modelValue", "label", "value", "onUpdate:modelValue"]))
    }), 128))
  ]))
}
}

})